import React, { useState } from "react";
import cropr from "../shared/utils/cropr";
import { gettext, interpolate } from "../shared/utils/legacy";
import { Modal } from "react-bootstrap";
import ModalHeader from "../shared/components/ModalHeader";
import CancelButton from "../shared/buttons/CancelButton";
import SaveButton from "../shared/buttons/SaveButton";
import ImageCard from "./ImageCard";
import DocCard from "./DocCard";
import Dropzone from "react-dropzone";
import { handleFileUpload } from "./utils";

const FileUploadModal = ({
  attachments,
  handleClose,
  show,
  onChange,
  onlyImages = false,
  storageType = "farm",
  singleSelect = false,
}: any) => {
  const [selected, setSelected] = useState<string[]>([]);
  const clickCard = (attachmentKey: string) => {
    if (selected.includes(attachmentKey)) {
      setSelected(selected.filter((item) => item !== attachmentKey));
    } else {
      if (singleSelect) {
        setSelected([attachmentKey]);
      } else {
        setSelected(selected.concat([attachmentKey]));
      }
    }
  };
  const [attachmentList, setAttachmentList] = useState<any[]>(() => {
    const allAttachments = cropr.images.models
      .concat(onlyImages ? [] : cropr.documents.models)
      .sort((a, b) => (a.get("last_modified") > b.get("last_modified") ? -1 : 1));
    return allAttachments.filter(
      (image) =>
        !attachments.map((a: any) => a.key).includes(image.get("key")) && image.get(storageType)
    );
  });
  const close = () => {
    setSelected([]);
    handleClose();
  };
  let aList = [...attachmentList];
  let selectedList = [...selected];

  const successCallback = (doc: any, collection: Backbone.Collection) => {
    collection.add(doc);
    aList = [doc, ...aList];
    setAttachmentList(aList);
    selectedList = [doc.get("key"), ...selectedList];
    setSelected(selectedList);
  };
  return (
    <Modal className="modal-md dfi-modal" show={show} onHide={close} data-backdrop={true}>
      <ModalHeader title={gettext("Upload attachment")} />
      <Modal.Body>
        <div className="row">
          <div className="col-12">
            <Dropzone onDrop={(files) => handleFileUpload(files, storageType, successCallback)}>
              {({ getRootProps, getInputProps }) => (
                <section>
                  <div {...getRootProps()}>
                    <input {...getInputProps()} />
                    <div
                      className="w-100 h-200px my-3 d-flex align-items-center justify-content-center"
                      style={{
                        borderStyle: "dashed",
                        borderColor: "#a9b7ba",
                        flexDirection: "column",
                      }}
                    >
                      <span className="d-block mb-2">
                        {gettext("Drag and drop multiple files here, or")}
                      </span>
                      <button type="button" className="btn btn-outline-smoke d-block">
                        {gettext("Upload a file")}
                      </button>
                    </div>
                  </div>
                </section>
              )}
            </Dropzone>
          </div>
          <div className="col-12 mb-1">
            <h4>
              {gettext("Recent files")}{" "}
              {selected.length ? interpolate("(%s selected)", [selected.length]) : ""}
            </h4>
          </div>
          <div className="col-12">
            <div className="img row py-3 mh-160px overflow-auto">
              {attachmentList.map((attachment, i) => (
                <div key={i} className="col-3 attachment-container py-2">
                  <div
                    className={`card border-0 attachment-select ${
                      selected.includes(attachment.get("key")) ? "selected" : ""
                    }`}
                  >
                    {attachment.get("filetype").includes("image") ? (
                      <ImageCard imageKey={attachment.get("key")} onClick={clickCard} />
                    ) : (
                      <DocCard
                        documentKey={attachment.get("key")}
                        documentFileType={attachment.get("filetype")}
                        clickDocument={clickCard}
                      />
                    )}
                    <ul className="list-group attachment-metadata">
                      <li className="list-group-item attachment-row border-0 py-1">
                        <div className="text-muted" style={{ fontSize: "0.6rem" }}>
                          {attachment.getCardString()}
                        </div>
                      </li>
                    </ul>
                  </div>
                </div>
              ))}
            </div>
          </div>
        </div>
      </Modal.Body>
      <Modal.Footer>
        <CancelButton onClick={close} />
        <SaveButton
          onClick={() => {
            close();
            onChange(selected);
          }}
        />
      </Modal.Footer>
    </Modal>
  );
};

export default FileUploadModal;
